import React from 'react';
import PropTypes from 'prop-types';
import { useState, useEffect } from 'react';
import GoogleClassroomShareModal from '../GoogleClassroomShareModal/index';
import MultiDropDown from '../MultiDropDown';
import Modal from '../Modal/index';
import CustomToast from '../Toast';
import HesSpinner from '../loadingOverlay/hesSpinner';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faTrash,
  faVolumeHigh,
  faCopy,
  faUsers,
  faEdit
} from '@fortawesome/free-solid-svg-icons';
import { faVolumeSlash } from '@fortawesome/pro-solid-svg-icons';
import {
  useLazyGetAssignmentLinksQuery,
  useDeleteAssignmentLinksMutation,
  useSaveAssignmentLinkNoteMutation
} from '../../features/authentication/authApiSlice';
import { OverlayTrigger, Tooltip, Col, Row } from 'react-bootstrap';
import StudentClipboardImg from '../../assets/images/studentClipboard.png';
import assignedVia_1 from '../..//assets/images/assignedVia_1.png';
import assignedVia_2 from '../../assets/images/assignedVia_2.png';
import assignedVia_3 from '../../assets/images/assignedVia_3.png';
import assignedVia_4 from '../../assets/images/assignedVia_4.png';
import { useGetAllAssignedViaMutation } from '../../features/authentication/authApiSlice';
import ConfirmationModal from '../ConfirmationPopUp';
import Prot from '../../../src/assets/images/Prot.svg';
import Ruler from '../../../src/assets/images/ruler.svg';

function Index({
  showAssignmentLinksModal,
  setShowAssignmentLinksModal,
  showAssignedViaFilter,
  assignmentIdFilter
}) {
  const [trigger, result] = useLazyGetAssignmentLinksQuery();
  const [assignmentLinks, setAssignmentLinks] = useState([]);
  const [deleteAssignmentLinkCall] = useDeleteAssignmentLinksMutation();
  const [saveAssignmentLinkNote] = useSaveAssignmentLinkNoteMutation();
  const [getAllAssignedVia] = useGetAllAssignedViaMutation();
  const [assignedViaList, setAssignedViaList] = useState([]);
  const [selectedAssignViaList, setSelectedAssignViaList] = useState([]);
  const [showShareToGoogleClassroomModal, setShowShareToGoogleClassroomModal] = useState(false);
  const [shareToGoogleGuid, setShareToGoogleGuid] = useState(null);
  const [shareToGoogleAssignmentName, setShareToGoogleAssignmentName] = useState(null);
  const [addNoteModel, setAddNoteModel] = useState(false);
  const [contentNote, setContentNote] = useState('');
  const [noteDescription, setNoteDescription] = useState('');
  const [urlGuid, setUrlGuid] = useState('');
  const [confirmModel, setConfirmModel] = useState(false);
  const [deleteAssignment, setDeleteAssignment] = useState('');

  useEffect(() => {
    if (showAssignmentLinksModal) {
      setAssignmentLinks([]);
      refetch();
    }
  }, [showAssignmentLinksModal]);

  function refetch() {
    getAllAssignedVia().then((response) => {
      setAssignedViaList(
        response.data.map((item) => {
          return { name: item.name, id: item.id, description: item.name, isChecked: true };
        })
      );
      setSelectedAssignViaList(response.data.map((item) => item.id));
    });

    trigger().then((response) => {
      if (!response.isSuccess) return;

      if (assignmentIdFilter && assignmentIdFilter.length > 0) {
        setAssignmentLinks(
          response.data.filter((link) => assignmentIdFilter.includes(link.assignmentId))
        );
      } else {
        setAssignmentLinks(response.data);
      }
    });
  }

  function copyLinkToClipboard(fullUrl) {
    navigator.clipboard.writeText(fullUrl);
    CustomToast('Link copied', 'info');
  }

  const confirmDelete = (assignment) => {
    setDeleteAssignment(assignment);
    setConfirmModel(true);
  };
  async function deleteAssignmentLink(urlLink) {
    try {
      deleteAssignmentLinkCall(urlLink.urlGuid)
        .unwrap()
        .then(() => {
          refetch();
          setConfirmModel(false);
          CustomToast('Assignment Link Deleted Successfully', 'success');
        });
    } catch {
      CustomToast('Error! Failed to delete assignment link', 'danger');
    }
  }
  const assignmentNoteDescription = (event) => {
    setContentNote(event.target.value);
    setNoteDescription(event.target.value);
  };
  const saveNote = async () => {
    const options = {
      note: noteDescription,
      urlGuid: urlGuid
    };
    const response = await saveAssignmentLinkNote(options).unwrap();
    if (response) {
      const updatedAssignmentLinks = assignmentLinks?.map((item) => {
        if (item.urlGuid === urlGuid) {
          return { ...item, note: noteDescription };
        }
        return item;
      });
      setAssignmentLinks(updatedAssignmentLinks);
      setAddNoteModel(false);
    }
  };

  function handleAssignedViaFilterChange(e) {
    const { key } = e;
    const selected = key !== '000' ? assignedViaList.find((v) => v.id == key) : assignedViaList;
    let tempValue = [];

    if (key === '000') {
      tempValue = assignedViaList.map((item) => ({
        ...item,
        isChecked: !assignedViaList.filter((item) => item?.isChecked !== true).length < 1
      }));
    } else {
      tempValue = assignedViaList.map((item) =>
        item.id == key ? { ...item, isChecked: !selected.isChecked } : item
      );
    }
    setAssignedViaList(tempValue);
    const ids = tempValue.filter((item) => item?.isChecked === true).map((itemId) => itemId.id);
    setSelectedAssignViaList(ids);
  }

  return (
    <>
      <Modal
        contentWidth="1200px"
        detailHeight="600px"
        isOpen={showAssignmentLinksModal}
        titleName={'Your Assignment Links'}
        onClose={() => setShowAssignmentLinksModal(false)}>
        <div className="public-assignments">
          <p>
            The following are Assignments Links that you own. Click{' '}
            <img src={assignedVia_2} className="img-fluid" alt="" /> to share to Google Classroom.
            Click{' '}
            <button className="assignmentlinkCopyBtn">
              {' '}
              <FontAwesomeIcon icon={faCopy} />
            </button>{' '}
            to copy link to clipboard then paste where you need it.
          </p>
          {showAssignedViaFilter && (
            <Row className="d-flex mb-4 align-items-center col-6">
              <Col>Assignment Method</Col>
              <Col className="col-7">
                <MultiDropDown
                  value={assignedViaList}
                  setValue={setAssignedViaList}
                  dropdownId="assignedViaFilter"
                  placeholder="Filter Assigned Via"
                  handleChange={(e) => handleAssignedViaFilterChange(e)}
                  selectedId={selectedAssignViaList}
                  setSelectedId={setSelectedAssignViaList}
                  description={true}
                  selectAllText="All Assigned Via"
                />
              </Col>
            </Row>
          )}
          <div className="custom-table table-responsive">
            <table className="table">
              <thead>
                <tr>
                  <th>Assignment</th>
                  <th>Date</th>
                  <th>Notes</th>
                  <th>Assigned Via</th>
                  <th>Details</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {result.isError && (
                  <tr>
                    <td colSpan="7" style={{ textAlign: 'center' }}>
                      <button
                        style={{
                          color: '#F84646',
                          fontSize: '1.15rem',
                          border: 'none',
                          background: 'none'
                        }}
                        onClick={() => refetch()}>
                        There was an error getting the data. Click to try again
                      </button>
                    </td>
                  </tr>
                )}
                {result.isFetching && assignmentLinks.length == 0 && (
                  <tr>
                    <td colSpan="7">
                      <div
                        className="d-flex justify-content-center align-items-center"
                        style={{ height: '40px' }}>
                        <HesSpinner />
                        <span className="ms-3">Loading results...</span>
                      </div>
                    </td>
                  </tr>
                )}

                {!result.isFetching && result.isSuccess && assignmentLinks.length == 0 && (
                  <tr>
                    <td colSpan="7">
                      <div
                        className="d-flex align-items-end justify-content-center text-align-center"
                        style={{
                          backgroundImage: `url(${StudentClipboardImg})`,
                          backgroundRepeat: 'no-repeat',
                          height: '130px',
                          backgroundPositionX: 'center'
                        }}>
                        {assignmentIdFilter && assignmentIdFilter.length == 0 ? (
                          <span>You do not have any assignment links created</span>
                        ) : (
                          <span>{`There are no assignment links for ${
                            assignmentIdFilter && assignmentIdFilter.length === 1 ? 'this' : 'these'
                          } assignment${
                            assignmentIdFilter && assignmentIdFilter.length === 1 ? '' : 's'
                          }`}</span>
                        )}
                      </div>
                    </td>
                  </tr>
                )}

                {assignmentLinks.map((item, index) => {
                  if (selectedAssignViaList.includes(item.assignedViaId) == false) return;
                  let assignedViaImage = null;
                  let tooltipContent = null;

                  switch (item.assignedViaId) {
                  case 1:
                    assignedViaImage = assignedVia_1;
                    tooltipContent = 'Castle';
                    break;
                  case 2:
                    assignedViaImage = assignedVia_2;
                    tooltipContent = 'Google Classroom';
                    break;
                  case 3:
                    assignedViaImage = assignedVia_3;
                    tooltipContent = 'Schoology';
                    break;
                  case 4:
                    assignedViaImage = assignedVia_4;
                    tooltipContent = 'Canvas';
                    break;
                  }
                  return (
                    <tr
                      key={`assignment-link-list-${item.urlGuid}`}
                      style={{ position: 'relative' }}>
                      <td>{item.assignmentName}</td>
                      <td>{item.dateTime}</td>
                      <td>
                        <div className="d-flex action-btns align-items-center">
                          {item.note}
                          <OverlayTrigger
                            key="editToolTip"
                            placement="top"
                            overlay={<Tooltip className="custom-tooltip">Click to Edit</Tooltip>}>
                            <button
                              className="orange-edit"
                              onClick={() => {
                                setAddNoteModel(true),
                                setContentNote(item.note),
                                setUrlGuid(item.urlGuid);
                              }}>
                              {' '}
                              <FontAwesomeIcon icon={faEdit} />
                            </button>
                          </OverlayTrigger>
                        </div>
                      </td>
                      <td>
                        <OverlayTrigger
                          key="assignedVia"
                          placement="top"
                          overlay={<Tooltip className="custom-tooltip">{tooltipContent}</Tooltip>}>
                          <img
                            src={assignedViaImage}
                            className="img-fluid"
                            alt=""
                            data-tooltip-id={`icon-${index}`}
                          />
                        </OverlayTrigger>
                      </td>
                      <td>
                        <div className="action-btns gap-2 align-items-center">
                          <div className="badge openBlue my-1">{item.assignmentMode}</div>
                          {item.startDate.length > 0 && (
                            <div>
                              From/To <br></br> {item.startDate} - {item.endDate}
                            </div>
                          )}
                          {item.timeSpan != null && item.timeSpan.length > 0 && (
                            <div>Timed {item.timeSpan}</div>
                          )}
                          <div className="d-flex gap-1 pt-1">
                            {item.randomize && <div className="text-primary px-1">R</div>}
                            {item.allowLanguageChange && (
                              <div className="text-primary px-1">LC</div>
                            )}
                            {item.timePeriod > 0 && (
                              <div className="text-primary px-1">
                                Time on Task ({item.timePeriod})
                              </div>
                            )}
                            {item.isCalculator && (
                              <div className="px-1">
                                {item.calculatorType === 1 && (
                                  <i
                                    style={{ color: 'red' }}
                                    title="A 4 Function calculator is available on screen for this assignment"
                                    className="fa fa-calculator calc-icon"></i>
                                )}
                                {item.calculatorType === 2 && (
                                  <i
                                    title="A Scientific calculator is available on screen for this assignment"
                                    className="fa fa-calculator calc-icon"></i>
                                )}
                              </div>
                            )}
                            {item.isProtractor && (
                              <div className="px-1">
                                <img
                                  title="A Protractor is available on screen for this assignment"
                                  src={Prot}
                                  className="key-icon"
                                />
                              </div>
                            )}
                            {item.isRuler && (
                              <div className="px-1">
                                <img
                                  title="A Ruler is available on screen for this assignment"
                                  src={Ruler}
                                  className="key-icon"
                                />
                              </div>
                            )}
                            <OverlayTrigger
                              key={`textToSpeech-${index}`}
                              placement="top"
                              overlay={
                                <Tooltip className="custom-tooltip">
                                    Text-to-Speech {item.readSpeaker ? ' Disabled' : ' Enabled'}
                                </Tooltip>
                              }>
                              <div className={`assignmentOptions ${item.readSpeaker ? 'bg-lightred' : 'bg-lightgreen'}`}>
                                <FontAwesomeIcon icon={item.readSpeaker ? faVolumeSlash : faVolumeHigh} className={item.readSpeaker ? 'danger-icon-btn' : 'success-icon-btn'} />
                              </div>
                            </OverlayTrigger>
                          </div>
                        </div>
                      </td>
                      <td>
                        <div className="action-btns d-flex justify-content-end gap-2">
                          <OverlayTrigger
                            key="copyToClipboard"
                            placement="top"
                            overlay={
                              <Tooltip className="custom-tooltip">Copy to Clipboard</Tooltip>
                            }>
                            <button
                              className="retake"
                              onClick={() => copyLinkToClipboard(item.fullUrl)}>
                              {' '}
                              <FontAwesomeIcon icon={faCopy} />
                            </button>
                          </OverlayTrigger>
                          {item.assignedViaId == 2 && (
                            <OverlayTrigger
                              key="shareToClassroom"
                              placement="top"
                              overlay={
                                <Tooltip className="custom-tooltip">
                                  Share to Google Classroom
                                </Tooltip>
                              }>
                              <button
                                className="pista-green"
                                onClick={() => {
                                  setShareToGoogleGuid(item.urlGuid);
                                  setShareToGoogleAssignmentName(item.assignmentName);
                                  setShowShareToGoogleClassroomModal(true);
                                }}>
                                {' '}
                                <FontAwesomeIcon icon={faUsers} />
                              </button>
                            </OverlayTrigger>
                          )}
                          <OverlayTrigger
                            key="deleteAssignment"
                            placement="top"
                            overlay={
                              <Tooltip className="custom-tooltip">Delete Assignment Link</Tooltip>
                            }>
                            <button
                              className="red"
                              onClick={() => {
                                confirmDelete(item);
                              }}>
                              {' '}
                              <FontAwesomeIcon icon={faTrash} />
                            </button>
                          </OverlayTrigger>
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      </Modal>
      <Modal
        contentWidth="600px"
        isOpen={addNoteModel}
        titleName={'Edit Notes'}
        onClose={() => setAddNoteModel(false)}>
        <textarea
          type="text"
          className="form-control textarea-lg"
          placeholder=" "
          name="noteDescription"
          id="noteDescription"
          value={contentNote}
          onChange={assignmentNoteDescription}
        />
        <div className="d-flex justify-content-end mt-3 gap-3 align-items-center">
          <button className="btn btn-castleGray print-btn" onClick={() => setAddNoteModel(false)}>
            Cancel
          </button>
          <button className="btn btn-castleRed print-btn" onClick={() => saveNote(false)}>
            Save
          </button>
        </div>
      </Modal>
      <ConfirmationModal
        isOpen={confirmModel}
        onClose={() => setConfirmModel(false)}
        onSave={() => deleteAssignmentLink(deleteAssignment)}
        contentWidth={'35%'}
        buttonPosition={'center'}
        content={`Are you sure that you want to delete the assignment link named "${deleteAssignment.assignmentName}"? All students will still see the link in their LMS but will not be able to start the assignment anymore. Please delete the assignment from your LMS if deleting here. This operation cannot be UNDONE!`}
        cancelButton={'No'}
        confirmButton={'Yes'}
      />
      <GoogleClassroomShareModal
        showShareToGoogleClassroomModal={showShareToGoogleClassroomModal}
        setShowShareToGoogleClassroomModal={setShowShareToGoogleClassroomModal}
        urlGuid={shareToGoogleGuid}
        assignmentName={shareToGoogleAssignmentName}
      />
    </>
  );
}

Index.propTypes = {
  showAssignmentLinksModal: PropTypes.bool,
  setShowAssignmentLinksModal: PropTypes.func,
  showAssignedViaFilter: PropTypes.bool,
  assignmentIdFilter: PropTypes.array
};

export default Index;
